module.exports = __webpack_public_path__ + "img/urc-logo-default.5ba4f2ef.png";